/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { variantOptionsStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsVariantOptions";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

variantOptionsStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px 12px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
        }
    `,
};
